<template>
  <div>
    <div class="container">
      <!-- BEGIN: Error Page -->
      <div
        class="error-page flex flex-col lg:flex-row items-center justify-center h-screen text-center lg:text-left"
      >
        <div class="text-white mt-10 lg:mt-0">
          <div class="intro-x text-8xl font-medium">User Not Active</div>
          <div class="intro-x text-xl lg:text-3xl font-medium mt-5">
            Oops. Looks like your account has been deactivated.
          </div>
          <div class="intro-x text-lg mt-3">
            Please contact us to reactivate your account if you are trying to
            manage your team.
          </div>
          <router-link
            to="/"
            class="intro-x btn py-3 px-4 text-white border-white dark:border-dark-5 dark:text-gray-300 mt-10"
          >
            Back to Home
          </router-link>
        </div>
      </div>
      <!-- END: Error Page -->
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  components: {},
  setup() {
    onMounted(() => {
      cash("body")
        .removeClass("main")
        .removeClass("login")
        .addClass("error-page");
    });
  }
});
</script>
